import { Link } from "react-router-dom";
import { MapPin, Hammer, ArrowRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import { CTABand } from "@/pages/About";
import { PROJECTS, ASSETS, BUSINESS } from "@/data";

export default function Projects() {
  return (
    <main data-testid="projects-page">
      <PageHero
        eyebrow="Our Work"
        title={<>RECENT<br />PROJECTS.</>}
        subtitle="A look at homes we've designed and built across Reno and Northern Nevada."
        image={ASSETS.heroTools}
      />

      <section className="bg-cream" style={{ backgroundColor: "var(--l3-cream)" }}>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
          {PROJECTS.length === 0 ? (
            <div data-testid="projects-empty" className="max-w-2xl mx-auto text-center py-12">
              <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center rounded-sm" style={{ backgroundColor: "var(--l3-wood-dark)" }}>
                <Hammer size={30} style={{ color: "var(--l3-gold)" }} />
              </div>
              <h2 className="font-display text-4xl mb-4" style={{ color: "var(--l3-wood-dark)" }}>
                OUR PORTFOLIO IS BEING UPDATED
              </h2>
              <p className="text-[16px] leading-relaxed mb-8" style={{ color: "#5b4f3d" }}>
                We're putting together a showcase of the homes we've built across {BUSINESS.serviceArea}.
                Check back soon — or reach out and we'll gladly walk you through our recent work.
              </p>
              <Link
                to="/contact"
                data-testid="projects-contact-btn"
                className="inline-flex items-center gap-2 font-cond tracking-widest px-9 py-4 btn-gold rounded-sm"
              >
                ASK ABOUT OUR WORK <ArrowRight size={18} />
              </Link>
            </div>
          ) : (
            <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
              {PROJECTS.map((p, i) => (
                <article
                  key={p.title}
                  data-testid={`project-${i}`}
                  className="group bg-white rounded-sm overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300"
                >
                  <div className="relative h-60 overflow-hidden">
                    <img
                      src={p.image}
                      alt={p.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <span className="absolute top-4 left-4 font-cond tracking-widest text-xs px-3 py-1.5 rounded-sm" style={{ backgroundColor: "var(--l3-gold)", color: "#1c140c" }}>
                      {p.type.toUpperCase()}
                    </span>
                  </div>
                  <div className="p-6">
                    <h3 className="font-cond font-semibold tracking-wide text-xl mb-1" style={{ color: "var(--l3-wood-dark)" }}>
                      {p.title}
                    </h3>
                    <p className="flex items-center gap-1.5 text-sm mb-3" style={{ color: "var(--l3-gold)" }}>
                      <MapPin size={14} /> {p.location}
                    </p>
                    <p className="text-[15px] leading-relaxed" style={{ color: "#5b4f3d" }}>{p.blurb}</p>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>

      <CTABand />
    </main>
  );
}
